﻿import window from 'window';
import document from 'document';
import { eventBus } from '../../foundation/eventBus';
export const collapsibleEvents = {
    trigger: 'trigger',
    disarm: 'disarm',
}

export const Collapsible = (elem, onToggled) => {
    const trigger = elem.querySelector(".dropdown__trigger");
    const activeClass = "active";

    function closeOnClickOutside(e) {
        if (window.innerWidth < 768)
            return;

        let targetElement = e.target;

        do {
            if (targetElement === elem) {
                return;
            }

            targetElement = targetElement.parentNode;
        } while (targetElement);

        close();
    }

    function checkKeys(e) {
        if (e.key === "Escape") {
            e.preventDefault();
            trigger.focus();
            close();
            return;
        }

        if (e.key === "Tab") {
            const firstItem = elem.querySelector(".dropdown__trigger.active + .dropdown__content .glider-slide:first-child li:first-child a");
            const lastItem = elem.querySelector(".dropdown__trigger.active + .dropdown__content .glider-slide:last-child li:last-child a");
            const currentItem = document.activeElement;

            if (currentItem === firstItem && e.shiftKey) {
                e.preventDefault();
                lastItem.focus();
            }
            if (currentItem === lastItem && !e.shiftKey) {
                e.preventDefault();
                firstItem.focus();
            }
        }
    }

    function handleClick(e) {
        var shouldClose = trigger.classList.contains(activeClass);
        let targetElement = e.currentTarget;

        // Store func so we have reference to remove event listener
        const checkWhichKey = function(event) {
            checkKeys(event);
        }

        if (shouldClose) {
            trigger.classList.remove(activeClass);
            trigger.setAttribute("aria-expanded", "false")
            document.removeEventListener("click", closeOnClickOutside);
            document.removeEventListener("keydown", checkWhichKey);
            eventBus.publish(collapsibleEvents.disarm);
        } else {
            trigger.classList.add(activeClass);
            trigger.setAttribute("aria-expanded", "true")
            document.addEventListener("click", closeOnClickOutside);
            document.addEventListener("keydown", checkWhichKey);
            eventBus.publish(collapsibleEvents.trigger, targetElement);
        }

        if (typeof onToggled === "function") {
            onToggled({ isOpen: !shouldClose });
        }
    }

    function handleKeyPress(e) {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleClick(e);
        }
    }

    function close() {
        trigger.classList.remove(activeClass);
    }

    trigger.addEventListener("click", handleClick);
    trigger.addEventListener("keydown", handleKeyPress);

    return {
        close: close
    };
};